import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import SubscriptionSummary from "./SubscriptionSummary";
import SubscriptionFilter from "./SubscriptionFilter";
import SubscriptionAmountAdjustment from "./SubscriptionAmountAdjustment";
import SubscriptionTable from "./SubscriptionTable";
import { getPaymentSummary } from "../../services/thunks/subscriptionThunks";
import { useThunk } from "../../hooks/useThunk";

const SubscriptionReport = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    status: "All",
    planType: "All",
    startDate: "",
    endDate: ""
  });
  const [summaryData, setSummaryData] = useState({
    activeSubscriptions: 0,
    totalRevenue: 0,
    avgValue: 0,
    couponsApplied: 0
  });
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [loading, setLoading] = useState(false);
 
  const tableRef = useRef(null);
  const [doPaymentSummary] = useThunk(getPaymentSummary);
 
  const fetchSummaryData = async (currentFilters = filters) => {
    try {
      setLoading(true);
     
      const response = await doPaymentSummary();
      console.log("Summary API response:", response);
      if (response?.success && response?.response?.data?.summary) {
        console.log("Setting summary data:", response.response.data.summary);
        setSummaryData(response.response.data.summary);
      } else if (response?.payload && response?.payload?.summary) {
        console.log("Setting summary data from payload:", response.payload.summary);
        setSummaryData(response.payload.summary);
      } else {
        console.warn("No summary data found in response:", response);
        setSummaryData({
          activeSubscriptions: 0,
          totalRevenue: 0,
          avgValue: 0,
          couponsApplied: 0
        });
      }
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setSummaryData({
        activeSubscriptions: 0,
        totalRevenue: 0,
        avgValue: 0,
        couponsApplied: 0
      });
    } finally {
      setLoading(false);
    }
  };

  const resetToFirstPage = () => {
    // Reset URL parameters to page 1
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "1");
    setSearchParams(newParams, { replace: true });
  };

  const handleApplyFilters = (newFilters) => {
   
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "1");
    
   
    if (newParams.has("pageSize")) {
      newParams.delete("pageSize");
    }
    
    // Apply filter parameters to URL as well
    Object.entries(newFilters).forEach(([key, value]) => {
      if (value && value !== "" && value !== "All") {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }
    });
    
    setSearchParams(newParams, { replace: true });
    
    setFilters(newFilters);
  setTimeout(() => {
      setRefreshTrigger(prev => prev + 1);
    }, 50);
    
   fetchSummaryData(newFilters);
  };

  useEffect(() => {
    console.log("Filters changed, fetching summary:", filters);
    fetchSummaryData();
  }, []);

  useEffect(() => {
    if (refreshTrigger > 0) {
      console.log("Refresh trigger changed, fetching summary");
     
      const timer = setTimeout(() => {
        fetchSummaryData();
      }, 500);
     
      return () => clearTimeout(timer);
    }
  }, [refreshTrigger]);

  return (
    <div className="p-6">
      <SubscriptionSummary
        data={summaryData}
        loading={loading}
      />
      
      <SubscriptionAmountAdjustment
        onSuccess={() => {
          setRefreshTrigger((prev) => prev + 1);
          fetchSummaryData();
        }}
      />
     
      <SubscriptionFilter
        onApply={handleApplyFilters}
        currentFilters={filters}
      />
     
      <SubscriptionTable
        ref={tableRef}
        filters={filters}
        refreshTrigger={refreshTrigger}
      />
    </div>
  );
};

export default SubscriptionReport;